<template>
  <div class="subvenue">
    <img class="part-1" src="@/assets/img/sub/part-1.webp" alt="">
    <div class="sub-container">
      <div class="sub-item">
        <img class="bg" src="@/assets/img/sub/cg.webp" alt="">
        <img class="btn" src="@/assets/img/sub/cg-btn.webp" @click="goLink('https://www.cgmodel.com/')" alt="">
      </div>
      <div class="sub-item">
        <img class="bg" src="@/assets/img/sub/ggac.webp" alt="">
        <img class="btn" src="@/assets/img/sub/ggac-btn.webp" @click="goLink('https://www.ggac.com')" alt="">
      </div>
      <div class="sub-item">
        <img class="bg" src="@/assets/img/sub/tywg.webp" alt="">
        <img class="btn" src="@/assets/img/sub/tywg-btn.webp" @click="goLink('https://www.gracg.com/home')" alt="">
      </div>
      <div class="sub-item">
        <img class="bg" src="@/assets/img/sub/manna.webp" alt="">
        <img class="btn" src="@/assets/img/sub/manna-btn.webp" @click="goLink('https://www.manamana.net/')" alt="">
      </div>
      <div class="sub-item">
        <img class="bg" src="@/assets/img/sub/px.webp" alt="">
        <img class="btn" src="@/assets/img/sub/px-btn.webp" @click="goLink('https://www.puxiang.com/')" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
export default {
  name: "Subvenue",
  setup() {
    const router = useRouter()
    function goLink(item) {
      window.location.href = item;
    }
    function goLinkSub(id) {
      router.push({
        path: "/subWorks",
        query: { subId: id },
      });
    }
    return {
      goLink,
      goLinkSub
    }
  },
};
</script>

<style lang="less">
.subvenue {
  background-image: url("../assets/img/bg3.png");
  background-size: cover;
  background-position: center;
  padding: 120px 0 100px 0;

  .part-1 {
    display: block;
    width: 352px;
    height: 112px;
    margin: 0 auto;
    margin-bottom: 62px;
  }

  .sub-container {
    width: 1125px;
    height: 1400px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;

    .sub-item {
      width: 1125px;
      height: 250px;
      margin-bottom: 30px;
      position: relative;

      .bg {
        width: 1125px;
        height: 250px;
        position: absolute;
        left: 0;
        top: 0;
      }

      .btn {
        height: 105px;
        position: absolute;
        top: 91px;
        right: 96px;
        cursor: pointer;
      }

      &:nth-of-type(1) {
        .btn {
          right: 88px;
        }
      }

      &:nth-of-type(3) {
        .btn {
          right: 46px;
        }
      }

    }
  }
}
</style>
